const pages = {
  app: {
    home: '/acasa',
    grid: '/rezolva-grile',
    subject: '/simulari',
    // The base of the only parameterised route in the app: one sitting's
    // results live at `${subjectResult}/${subjectId}`. Kept as the base so
    // link builders and the route table read the same constant.
    subjectResult: '/simulare-incheiata',
    dashboard: '/statistici',
    ranking: '/clasament',
    history: '/istoric-grile',
    payment: '/abonamente',
    profile: '/profil',
    contact: '/contact',
    createGrid: '/creaza-grila',
    createSubject: '/creaza-subiect',
    createMail: '/creaza-mail',
    createVoucher: '/creaza-voucher',
    reports: '/rapoarte',
    teacher: '/profesor',
  },
  auth: {
    login: '/login',
    register: '/signup',
    forgotPassword: '/recuperare-parola',
    resetPassword: '/resetare-parola',
    unsubscribe: '/dezabonare',
    confirmAccount: '/confirmare-cont',
  },
  other: {
    privacyPolicy: '/politica-de-confidentialitate',
    termsAndConditions: '/termeni-si-conditii',
  },
}

export default pages
